import React from 'react';
import './organigramme.css';
import { Footer, Header } from '../index';
import organigramme from '../../asserts/images/organigramme.jpg';
import { Link } from 'react-router-dom';

function Organigramme(props) {
  return (
    <div style={{ backgroundColor: '#FCFCFC' }}>
      <Header />
      <div className='containerINFO'>
        <div className='introrg'>  </div>
        <div className="container-fluid text-white text-center" style={{ position: 'relative', marginTop: '-130px', marginBottom: '100px' }}>
          <h1 style={{fontFamily:'fantasy', fontSize:'50px'}}className="container-fluid text-white text-center " id='h1org'>Notre Organigramme</h1>
          <p className="container-fluid text-white text-center" ><Link className='linkorg' to="/">Accueil</Link> <span>{'>'}</span><Link className='linkorg'
            to="/"> ISIMM </Link>  <span>{'>'}</span> <Link className='linkorg'
            to="/">Organigramme</Link> </p></div>
      </div>
      <div className="orgbody" style={{ backgroundColor: '#FCFCFC' }}>
      <img src={organigramme} className="org" alt="organigramme" />
     
      </div>
      <Footer />
    </div>
  )
}

export default Organigramme;
 /*<a target="_blank" href="/images/organigramme.jpg">
    </a>*/